module.exports = __webpack_public_path__ + "images/3816b7b3594f52b2df59fda534ceb76f.svg";